import axios from "axios";

export const STUDENT_URL = "/Student";
export const DAILY_ATTENDANCE_REPORT_URL = "/DailyAttendanceReport";

/** Mevcut Okula Ait Belli Bir Günlük Yoklama Raporunu Elde Eder */
export function getDailyAttendanceReport(queryParams) {
  return axios.post(`${DAILY_ATTENDANCE_REPORT_URL}/GetDailyAttendanceReport`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Günlük Yoklama Raporunu Sayfalama Olmadan Elde Eder */
export function getAllDailyAttendanceReport(queryParams) {
  return axios.post(`${DAILY_ATTENDANCE_REPORT_URL}/GetAllDailyAttendanceReport`, queryParams);
}

/** Mevcut Okula Ait Mevcut Dönemdeki Şube, Danışman Öğretmen ve Öğretmen Listesini Elde Eder */
export function getAllList() {
  return axios.get(DAILY_ATTENDANCE_REPORT_URL);
}

/** Mevcut Okula Ait Belli Bir Dönemdeki Danışman Öğretmen, Öğretmen ve Belli Bir Sınıftaki Öğrenci Listesini Elde Eder */
export function getList(term, sectionId) {
  return axios.get(`${DAILY_ATTENDANCE_REPORT_URL}/${term}/${sectionId}`);
}

/** Mevcut Okula Ait Belli Bir Dönemdeki Danışman Öğretmen ve Öğretmen Listesini Elde Eder */
export function getAdvisorsAndTeachers(term) {
  return axios.get(`${DAILY_ATTENDANCE_REPORT_URL}/${term}`);
}

/** Mevcut Okula Ait Bir Dönemde Belli Bir Sınıftaki Öğrenci Listesini Elde Eder */
export function getStudents(term, sectionId) {
  return axios.get(`${STUDENT_URL}/GetStudentsInSection/${term}/${sectionId}`);
}